/**
 * HomeFooter — 홈 B2B 리뉴얼 푸터(작게). B2C·SaaS 회수 동선 + 법적 링크.
 * 모든 문구/링크는 copy.js(FOOTER)에서 가져옴. 하드코딩 0.
 * 라우터=preact-router → 내부 이동은 동일 출처 <a href>(자동 인터셉트), 외부는 target=_blank.
 */
import styles from '../../styles/HomeFooter.module.css';
import { FOOTER } from './copy';

export default function HomeFooter() {
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        {/* B2C·SaaS 회수 링크 (내부 라우트 = a href, preact-router 자동 처리) */}
        <nav className={styles.links}>
          {FOOTER.links.map((link) =>
            link.external ? (
              <a key={link.href} href={link.href} target="_blank" rel="noopener noreferrer" className={styles.link}>
                {link.label}
              </a>
            ) : (
              <a key={link.href} href={link.href} className={styles.link}>
                {link.label}
              </a>
            ),
          )}
        </nav>

        {/* 법적 링크 (외부 노션 = target=_blank) */}
        <nav className={styles.legal}>
          {FOOTER.legal.map((item) => (
            <a
              key={item.href}
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.legalLink}>
              {item.label}
            </a>
          ))}
        </nav>

        <p className={styles.copyright}>{FOOTER.copyright}</p>
      </div>
    </footer>
  );
}
